import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {UmUserService} from "../../../../service/api/um-user.service";
import {RoleService} from "../../../../service/api/role.service";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {ObjectRequestList} from "../../../../../../core/shared/dto/object/request/object-request-list";
import {Sorting} from "../../../../../../core/shared/misc/sorting";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {DatesHelper} from "../../../../../../core/shared/helper/dates-helper";

@Component({
    selector: 'mvs-example',
    templateUrl: 'um-statistics.component.html',
    standalone: false
})
export class UmStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {

    activeUsers: number = 0;
    inactiveUsers: number = 0;
    newUsers: number = 0;
    workingHours: number = 0;

    userAccessStatisticsWidget: WidgetData;
    permissionGroupsWidget: WidgetData;
    userStatusBreakdownWidget: WidgetData;
    recentlyJoinedUsersWidget: WidgetData;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;

    overviewDto: OverviewDto[];

    constructor(
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected userService: UmUserService,
        protected roleService: RoleService) {
        super(route, coreService)
    }

    ngOnInit(): void {

        this.items = [
            {label: 'User Module'},
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};

        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        this.getTotalUsers();
        this.getUserOverviewThisMonth();
        this.refreshRecentlyJoinedUsers();
        this.refreshUserStatistics();
        this.refreshPermissionGroupWidgets();
        this.refreshStatusBreakdownWidgets();
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/um/config']);
    }

    getTotalUsers() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [],
            [],
            ['enabled'],
            [new ObjectRequestListAttribute('enabled', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.userService.groupBy(objectRequestList).subscribe(res => {
            this.overviewDto = [
                {label: 'Active Users', value: 0},
                {label: 'Inactivated', value: 0}
            ];

            for (let entry of res.entries) {
                if (entry['enabled'] == true) {
                    this.overviewDto.find(item => item.label === 'Active Users').value = entry['enabled_count'];
                } else {
                    this.overviewDto.find(item => item.label === 'Inactivated').value = entry['enabled_count'];
                }
            }

        });
    }


    getUserOverviewThisMonth() {
        const objectRequestList = ObjectRequestList.createBasic(
            false,
            [FilterCriteria.create('createdDate', FilterCriteria.cOperatorGreaterEqual, DatesHelper.calculateFirstDayOfCurrentMonth())],
            []);

        this.userService.list(objectRequestList).subscribe(res => {
            this.newUsers = res.entries.length;
        });

    }

    refreshUserStatistics() {
        this.userAccessStatisticsWidget = WidgetFactory.createWidget(
            'um.user.overview.user.access.statistics.widget',
            'User Access Statistics',
            'history.chart',
            'list',
            'entity.groupBy',
            'ig.IgAccessToken',
            WidgetDataParam.create("fieldCategory", "user"),
            WidgetDataParam.create("fieldCategoryCount", "user_count"),
            WidgetDataParam.create("historyPeriodMode", "year"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.userAccessStatisticsWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["user", "createdDate"],
            [new ObjectRequestListAttribute("user", "Anzahl", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshPermissionGroupWidgets() {
        this.permissionGroupsWidget = WidgetFactory.createWidgetGroupBy(
            'um.user.overview.permission.group.widget',
            'Permission Group',
            'category',
            'entity.groupBy',
            'um.UserRole',
            'role',
            'role_count',
            this.filterCriteria,
            'role',
            'Anzahl');
    }

    refreshStatusBreakdownWidgets() {
        this.userStatusBreakdownWidget = WidgetFactory.createWidgetGroupBy(
            'um.user.overview.status.breakdown.widget',
            'User Status Breakdown',
            'category',
            'entity.groupBy',
            'um.User',
            'enabled',
            'enabled_count',
            this.filterCriteria,
            'enabled',
            'Anzahl');
    }

    refreshRecentlyJoinedUsers() {
        this.recentlyJoinedUsersWidget = WidgetFactory.createWidgetTableEntityQl('um.user.overview.recently.joined.user', 'Recently Joined Users', 'um.User', 'No Fields', this.filterCriteriaForQuery, [
            new Sorting("e.createdDate", false)
        ]);
    }


    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
